import "../css/app.css";
import "lazysizes";
import Alpine from "alpinejs";
import baguetteBox from "baguettebox.js";
import { Splide } from "@splidejs/splide";
import "./cookie.js";

window.Alpine = Alpine;

Alpine.data("counter", () => ({
  count: 0,
  fetch() {
    fetch("/api", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `
          query CountQuery {
            entryCount(section: "news")
          }
          `,
        variables: {},
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        this.count = result.data.entryCount;
        console.log(result.data.entryCount);
      });
  },
}));

Alpine.data("video", () => ({
  currentTime: 0,
  seekTo(time) {
    this.$refs.video.currentTime = time;
  },
}));

Alpine.start();

baguetteBox.run(".baguette", {
  noScrollbars: true,
  async: true,
});

document.addEventListener("DOMContentLoaded", function () {
  const elmsGallery = document.getElementsByClassName("splide-gallery");
  for (let i = 0, len = elmsGallery.length; i < len; i++) {
    new Splide(elmsGallery[i], {
      type: "loop",
      lazyLoad: "nearby",
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: true,
      autoplay: false,
      arrowPath: "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z",
    }).mount();
  }
});

// Timeline animations
document.addEventListener("DOMContentLoaded", function () {
  const timelineBlocks = document.querySelectorAll(".timeline__block");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const block = entry.target;

          // Animate content
          const leftContent = block.querySelector(".timeline__content--left");
          const rightContent = block.querySelector(".timeline__content--right");
          const dot = block.querySelector(".timeline__dot");
          const dateLeft = block.querySelector(".timeline__date--left");
          const dateRight = block.querySelector(".timeline__date--right");

          // Add transition classes
          if (leftContent) {
            leftContent.classList.add("animate-timeline");
          }
          if (rightContent) {
            rightContent.classList.add("animate-timeline");
          }
          if (dot) {
            dot.classList.add("animate-dot");
          }
          if (dateLeft) {
            dateLeft.classList.add("animate-date");
          }
          if (dateRight) {
            dateRight.classList.add("animate-date");
          }

          observer.unobserve(block);
        }
      });
    },
    {
      threshold: 0.3,
      rootMargin: "0px 0px -300px 0px",
    }
  );

  timelineBlocks.forEach((block) => observer.observe(block));
});
